import * as React from "react";
import { forwardRef } from "react";
const SvgCheckMark = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={9} ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="M4.414 5.243 9.657 0l1.414 1.414-5.243 5.243L4.414 8.07.88 4.536 2.293 3.12z" /></svg>;
const ForwardRef = forwardRef(SvgCheckMark);
export default ForwardRef;